import { render, staticRenderFns } from "./group.principal.vue?vue&type=template&id=04778990&"
import script from "./group.principal.vue?vue&type=script&lang=js&"
export * from "./group.principal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports